export const GALLERY_COLLECTIONS = {
    'mulch soil and stone': {
        name: 'Mulch, Soil & Stone',
        categories: [
            'bagged-mulch',
            'bagged-soil-sand',
            'bagged-soil-sand-premium',
            'bagged-stone',
            'bulk-mulch',
            'bulk-soil',
            'bulk-sand',
            'bulk-stone'
        ],
        shopEnabled: true
    },
    'garden and lawn treatment': {
        name: 'Garden & Lawn Treatment',
        categories: ['fertilizers', 'grass-seed', 'organics', 'pest-control', 'weed-control']
    },
    'landscape supplies': {
        name: 'Landscape Supplies',
        categories: ['edging', 'garden-tools', 'gloves', 'landscape-fabric', 'tree-stakes', 'watering']
    },
    'outdoor living': {
        name: 'Outdoor Living',
        categories: ['decor', 'decor-pottery', 'furniture']
    },
    plants: {
        name: 'Plants',
        categories: [
            'annual',
            'annual-hanging-basket',
            'edible-fruit',
            'edible-vegetable',
            'groundcover-vines',
            'indoor-plants',
            'ornamental-grass',
            'perennial',
            'rose',
            'shrub-deciduous',
            'shrub-evergreen',
            'shrub-evergreen-broadleaf',
            'topiary',
            'tree-evergreen',
            'tree-fruit',
            'tree-ornamental',
            'tree-shade'
        ]
    },
    seasonal: {
        name: 'Seasonal',
        categories: ['seasonal-fall', 'seasonal-winter', 'seasonal-spring']
    },
    'patio wall and walkway stone': {
        name: 'Patio, Wall, & Walkway Stone',
        categories: ['natural-stone', 'paver-stone', 'wallstone-block']
    }
};
export const GALLERY_CATEGORIES = {
    ANNUAL: {
        name: 'Annuals',
        description: 'Annuals are plants that provide an abundance of color and appeal to your landscape. They traditionally last one season and are replaced each year in spring.'
    },
    'ANNUAL-HANGING-BASKET': {
        name: 'Hanging Baskets',
        description: ''
    },
    'BAGGED-MULCH': {
        name: 'Bagged Mulch',
        description: `Russell's Tree and Shrub Farm LLC bagged mulch products come in either 2 or 3 cubic foot bags. Russell's carries a large variety of hardwood and cedar mulches. We also carry a large variety of bagged ornamental stone products and are sold in half cubic foot bags.`
    },
    'BAGGED-SOIL-SAND': {
        name: 'Bagged Soil & Sand',
        description: `Russell's Tree and Shrub Farm LLC bagged mulch products come in either 2 or 3 cubic foot bags. Russell's carries a large variety of hardwood and cedar mulches. We also carry a large variety of bagged ornamental stone products and are sold in half cubic foot bags.`
    },
    'BAGGED-SOIL-SAND-PREMIUM': {
        name: 'Premium Bagged Soil',
        description: `Healthy plants start from the ground up—literally. Our premium bagged soils are crafted with rich organic ingredients, optimal drainage, and nutrient balance to give your plants the best possible start. Unlike the generic mixes found at big box stores, these top-tier blends are hand-selected and only available right here at our garden center—so you can grow with confidence, knowing you're giving your plants the very best.`
    },
    'BAGGED-STONE': {
        name: 'Bagged Stone',
        description: `Russell's Tree and Shrub Farm LLC bagged mulch products come in either 2 or 3 cubic foot bags. Russell's carries a large variety of hardwood and cedar mulches. We also carry a large variety of bagged ornamental stone products and are sold in half cubic foot bags.`
    },
    'BULK-MULCH': {
        name: 'Bulk Mulch',
        description: `Russell's Tree and Shrub Farm LLC bulk products, which include a range of natural and dyed hardwood mulches, topsoil, compost and stone products, are high quality and used throughout the Amherst area and beyond.`,
        shopEnabled: true
    },
    'BULK-SOIL': {
        name: 'Bulk Soil',
        description: `Russell's Tree and Shrub Farm LLC bulk products, which include a range of natural and dyed hardwood mulches, topsoil, compost and stone products, are high quality and used throughout the Amherst area and beyond.`,
        shopEnabled: true
    },
    'BULK-SAND': {
        name: 'Bulk Sand',
        description: `Russell's Tree and Shrub Farm LLC bulk products, which include a range of natural and dyed hardwood mulches, topsoil, compost and stone products, are high quality and used throughout the Amherst area and beyond.`,
        shopEnabled: true
    },
    'BULK-STONE': {
        name: 'Bulk Stone',
        description: `Russell's Tree and Shrub Farm LLC bulk products, which include a range of natural and dyed hardwood mulches, topsoil, compost and stone products, are high quality and used throughout the Amherst area and beyond.`,
        shopEnabled: true
    },
    DECOR: {
        name: 'Decór',
        description: ''
    },
    'DECOR-POTTERY': {
        name: 'Pottery',
        description: ''
    },
    EDGING: {
        name: 'Edging',
        description: ''
    },
    'EDIBLE-FRUIT': {
        name: 'Edible Fruit',
        description: `Russell's has many different varieties of fruit shrubs and trees available. We can provide instructions on how to make sure you are getting the most out of your fruit plant and how to produce healthy, uncontaminated fruit!`
    },
    'EDIBLE-VEGETABLE': {
        name: 'Edible Vegetable',
        description: `Russell's has many different varieties of fruit shrubs and trees available. We can provide instructions on how to make sure you are getting the most out of your fruit plant and how to produce healthy, uncontaminated fruit!`
    },
    FERTILIZERS: {
        name: 'Fertilizers',
        description: `We offer you plenty of different solutions to help keep your gardens looking great. From our organic fertiilizer solutions to our various other gardening products, you'll find everything you need. Looking for that golf course lawn? Let us help you with our fertilizers and other products to keep your lawn green and have your neighbors wondering where you got your treatment.`
    },
    FURNITURE: {
        name: 'Furniture',
        description: `Russell's Tree and Shrub Farm carries the Leisure Lawns Collection of furniture. Every piece is handmade, hand cut and screwed together with only the highest quality products. This quality is not readily available in today’s world of furniture. If you want a maintenance free approach to outdoor living, you need this lawn furniture! This beautiful, colorful and very durable furniture loves the outdoors and is maintenance free.`
    },
    'GARDEN-TOOLS': {
        name: 'Garden Tools',
        description: ''
    },
    GLOVES: {
        name: 'Landscape Gloves',
        description: ''
    },
    'GRASS-SEED': {
        name: 'Grass Seed',
        description: ''
    },
    'GROUNDCOVER-VINES': {
        name: 'Groundcover Vines',
        description: ''
    },
    'INDOOR-PLANTS': {
        name: 'Indoor Plants',
        description: ''
    },
    'LANDSCAPE-FABRIC': {
        name: 'Landscape Fabric',
        description: ''
    },
    'NATURAL-STONE': {
        name: 'Natural Stone',
        description: ''
    },
    ORGANICS: {
        name: 'Organic Treatments',
        description: ''
    },
    'ORNAMENTAL-GRASS': {
        name: 'Ornamental Grass',
        description: 'Russell’s carries a huge selection of ornamental grasses. These plants can be used to accent current plants or act as stand-alone plants. They are extremely hardy and love lots of water when they are getting established. Some varieties can also grow in excess of 10’+ tall!! Work some of these versatile plants into your landscape to add a fun but functional accent.'
    },
    'PAVER-STONE': {
        name: 'Pavers',
        description: ''
    },
    PERENNIAL: {
        name: 'Perennials',
        description: `Perennials make up a group of plants that are hardy enough to return year after year. These plants generally are smaller than shrubs and help provide unique colors and textures to your garden.`
    },
    'PEST-CONTROL': {
        name: 'Pest Control',
        description: `At Russell's we have various repellents to keep annoying animals away. Deer, rabbits and more!`
    },
    ROSE: {
        name: 'Roses',
        description: `A rose is a perennial plant. There are over 100 species and Russell's provides many of the ones that are friendly in our climate. They form a group of erect shrubs, and climbing or trailing plants, with stems that are often armed with sharp prickles. Flowers are large and showy, in a number of colors from white through yellows and reds.`
    },
    'SEASONAL-FALL': {
        name: 'Fall',
        description: 'Fall items including pumpkins, hay bayles, corn stalks and more. Many different sized pumpkins and gourds available.'
    },
    'SEASONAL-SPRING': {
        name: 'Spring',
        description: 'Spring items include various bulb flowers and more.'
    },
    'SEASONAL-WINTER': {
        name: 'Winter',
        description: `You'll find different Christmas trees like Fraser fir, Douglas Fir, Colorado Spruce, and more. Fresh cut wreaths ready to go or get a custom made wreath.`
    },
    'SHRUB-DECIDUOUS': {
        name: 'Deciduous Shrubs',
        description: `Deciduous shrubs are shrubs that will lose it's leafs and flowers come fall and winter. In the spring the plants will push out new growth to regain the plant's integrity. Our selection of shrubs is second to none. We pride ourselves on selecting the healthiest and hardiest varieties to offer you at our everyday low prices.`
    },
    'SHRUB-EVERGREEN': {
        name: 'Evergreen Shrubs',
        description: `Evergreens are plants with leaves (in the form of needles) that remain intact from season to season. These plants are known for their ability to act as privacy barriers during the winter months.`
    },
    'SHRUB-EVERGREEN-BROADLEAF': {
        name: 'Broad Leaf Evergreen Shrubs',
        description: `Broad Leaf Evergreens are plants with leaves that remain intact from season to season. These plants are known for their ability to act as privacy barriers during the winter months.`
    },
    TOPIARY: {
        name: 'Topiary + Exotics',
        description: `Russell's carries a comination of topiaries & specialties. These plants are either pruned and cultivated to a unique look or these plants are unique by nature. In some cases these plants may require additional pruning and care to retain the desired look of the plant.`
    },
    'TREE-EVERGREEN': {
        name: 'Evergreen Trees',
        description: `Evergreen trees primarily hold the same attributes as evergreen shrubs aside from their ability to grow into much larger speciments. Evergreens are plants with leaves (in the form of needles) remain intact from season to season. These plants are known for their ability to act as privacy barriers during the winter months.`
    },
    'TREE-FRUIT': {
        name: 'Fruit Trees',
        description: ''
    },
    'TREE-ORNAMENTAL': {
        name: 'Ornamental Trees',
        description: `Ornamental trees are traditionally used as a specimen type of tree. These trees are not cultivated to produce shade but to accent your property with a tree that can potentially produce flowers or even fragrances!`
    },
    'TREE-SHADE': {
        name: 'Shade Trees',
        description: `A shade tree is any tree grown specifically for its shade. "Shade tree" usually applies to large trees with spreading canopies. Shade trees are effective in reducing the energy used in cooling homes. Russell's growing stock is filled with many varieties of shade trees.`
    },
    'TREE-STAKES': {
        name: 'Tree Stakes',
        description: ''
    },
    'WALLSTONE-BLOCK': {
        name: 'Wallstone Block',
        description: ''
    },
    WATERING: {
        name: 'Watering Supplies',
        description: ''
    },
    'WEED-CONTROL': {
        name: 'Weed Control',
        description: `We offer you plenty of different solutions to help keep your gardens looking great. From our organic fertiilizer solutions to our various other gardening products, you'll find everything you need. Looking for that golf course lawn? Let us help you with our fertilizers and other products to keep your lawn green and have your neighbors wondering where you got your treatment.`
    }
};
export function isValidGalleryCategory(category) {
    const keys = Object.keys(GALLERY_CATEGORIES);
    const valid = category && keys.indexOf(category.toUpperCase()) > -1;
    return valid;
}
